import { FormControl, Grid, TextField, Typography, Box } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as configuracionService from "../services/configuracionService";
import { setEntity, setData, setValidationMessage } from "../redux/configuracionSlice";

// Lo que conviene saber de los parametros que el sistema lee solo.
const NOTAS = {
    BITACORA_ACTIVA: "S registra cada cambio de cada tabla en la bitacora "
        + "(bitacoracambio); N la apaga. El cambio se nota al instante.",
};

// Los datos de un parametro del sistema.
const Configuracion = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const entity = useSelector((state) => state.configuracion.entity);
    const defaultEntity = useSelector((state) => state.configuracion.defaultEntity);
    const validate = useSelector((state) => state.configuracion.validationActive);
    const dispatch = useDispatch();

    var validation = {
        codigo: {
            error: entity.codigo == null || entity.codigo.trim().length < 1,
            message: "Falta ingresar el codigo",
        },
        valor: {
            error: entity.valor == null || entity.valor.trim().length < 1,
            message: "Falta ingresar el valor",
        },
    }

    const fetchEntity = useCallback(async () => {
        if (parseInt(params.id || "0") <= 0) {
            dispatch(setEntity(defaultEntity));
            return;
        }

        const fila = await configuracionService.getConfiguracion(parseInt(params.id))
            .catch((err) => { console.log("Err: ", err); return null; });

        dispatch(setEntity(fila == null ? defaultEntity : fila));
    }, [])

    useEffect(() => {
        fetchEntity();
    }, [])

    useEffect(() => {
        dispatch(setValidationMessage(messagesValidation()));
    }, [entity])

    var setDataEntity = e => {
        dispatch(setData(e.target));
    }

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    return (
        <Grid container>
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Parametro
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={12} sm={4}>
                    <FormControl required fullWidth error={validate.codigo && validation.codigo.error}>
                        <TextField
                            name="codigo"
                            label="Codigo"
                            fullWidth
                            value={entity.codigo}
                            onChange={setDataEntity}
                            error={validate.codigo && validation.codigo.error}
                            helperText={validate.codigo && validation.codigo.error
                                ? validation.codigo.message
                                : "Como lo llama el sistema: no cambie un codigo que ya existe"}
                            disabled={isReadOnly}
                            size="small"
                            inputProps={{ maxLength: 50 }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField
                        name="descripcion"
                        label="Descripcion"
                        fullWidth
                        value={entity.descripcion}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        inputProps={{ maxLength: 50 }}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormControl required fullWidth error={validate.valor && validation.valor.error}>
                        <TextField
                            name="valor"
                            label="Valor"
                            fullWidth
                            value={entity.valor}
                            onChange={setDataEntity}
                            error={validate.valor && validation.valor.error}
                            helperText={validate.valor && validation.valor.error
                                ? validation.valor.message
                                : NOTAS[entity.codigo] || ""}
                            disabled={isReadOnly}
                            size="small"
                            inputProps={{ maxLength: 50 }}
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
    );
}
export default Configuracion;
